<template>
  <x-page title="售后记录" :loading="loading">
    <x-card>
      <div class="list">
        <div
          v-for="item in list"
          :key="item.time"
          :class="['item', !item.activeFlag && 'gray']"
        >
          <div v-if="item.title" class="title">{{ item.title }}</div>
          <div v-if="item.description" class="desc">{{ item.description }}</div>
          <div class="time">{{ item.time }}</div>
          <img
            :src="
              !!item.activeFlag
                ? require('./images/指示点_高亮.png')
                : require('./images/指示点.png')
            "
            class="dot"
          />
        </div>
      </div>
    </x-card>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiSaleAfterStandardEcommerceSaleAfterGetSolveRecord } from '@/api'
  import { mapQuery, prepareData, Track } from '@/utils'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      mapQuery({
        // 售后 ID
        id: 'id',
      }),
      Track.provideMark(() => ({
        page: '售后记录',
      })),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,
      // 处理记录
      list: [],
    }),

    async mounted() {
      const { list } = await prepareData({
        list: apiSaleAfterStandardEcommerceSaleAfterGetSolveRecord({
          id: this.id,
        }),
      })
      this.list = list
      this.loading = false
    },
  })
</script>

<style lang="scss" scoped>
  .list {
    padding-top: 4px;
    padding-left: 36px;

    .item {
      position: relative;

      .title {
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }

      .desc {
        margin-top: 8px;
        font-size: 14px;
        color: #222222;
        line-height: 19px;
      }

      .time {
        margin-top: 10px;
        font-size: 12px;
        color: #bebebe;
      }

      &:not(:first-child) {
        margin-top: 16px;
      }

      &.gray {
        .title {
          color: #888888;
        }

        .desc {
          color: #888888;
        }
      }

      &:not(:last-child):before {
        content: '';
        position: absolute;
        left: -18px;
        top: 0;
        bottom: -16px;
        width: 1px;
        background-color: #cdcdcd;
      }

      .dot {
        position: absolute;
        left: -30px;
        top: 0;
        width: 24px;
        height: 24px;
      }
    }
  }
</style>
